<template>
    <div class="information_box">
        <div class="inform_tit"> 
            <div @click="cancel" class='cancel_box'>
                <i class="el-icon-back myback_icon"></i> Back
            </div>
        </div>
        <div class="inMain_box">
            <div class="informdata_tit">Create New Venue</div>
            <el-form :model="ruleForm" label-position="top" :rules="rules" :hide-required-asterisk="false" ref="ruleForm" label-width="100px" class="information-ruleForm">
                <el-form-item label="Venue Name" prop="name">
                    <el-input class="venueInformation_input" maxlength="50" v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="Venue Owner" prop="owner">
                    <el-input class="venueInformation_input" maxlength="50" v-model="ruleForm.owner"></el-input>
                </el-form-item>
                <el-form-item label="Contact Number" prop="contactNumber">
                    <el-input v-model="ruleForm.contactNumber" maxlength="10" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="ABN" prop="abn">
                    <el-input v-model="ruleForm.abn" maxlength="11" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Venue Description">
                    <div slot="label"><span class="err_span">*</span> Venue Description</div>
                    <div class="checkBox_list">
                        <div class="venue_checkBox">
                            <span @click="ruleForm.bar==1?ruleForm.bar=0:ruleForm.bar=1" class="venue_check" :class="{'venue_checked':ruleForm.bar==1}"></span>
                            <span class="venueCheckBox_msg" @click="ruleForm.bar==1?ruleForm.bar=0:ruleForm.bar=1">Bar</span>
                        </div>
                        <div class="venue_checkBox">
                            <span @click="ruleForm.cafe==1?ruleForm.cafe=0:ruleForm.cafe=1" class="venue_check" :class="{'venue_checked':ruleForm.cafe==1}"></span>
                            <span class="venueCheckBox_msg" @click="ruleForm.cafe==1?ruleForm.cafe=0:ruleForm.cafe=1">Cafe</span>
                        </div>
                        <div class="venue_checkBox">
                            <span @click="showDescriptionSel" class="venue_check" :class="{'venue_checked':ruleForm.restaurant==1}"></span>
                            <span class="venueCheckBox_msg" @click="showDescriptionSel">Restaurant</span>
                            <transition name="el-zoom-in-center">
                            <el-select v-show="ruleForm.restaurant==1" v-model="ruleForm.restaurantCkeck" placeholder="" class="myVenue_sel" :class="{'showSelect':ruleForm.restaurant}">
                                <el-option
                                v-for="item in ['Fast Food','Quick Service','Fast Casual','Fine Dining']"
                                :key="item"
                                :label="item"
                                :value="item">
                                </el-option>
                            </el-select>
                            </transition>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="Cuisine Type">
                    <div slot="label"><span class="err_span">*</span> Cuisine Type</div>
                    <el-button icon="el-icon-circle-plus-outline" class="venueAddtype_btn" @click="showCuisDio">Add Type</el-button>
                    <div class="venueType_box" v-for="(item,i) in ruleForm.cuisineCheckd" :key="i">
                        {{item}} <i class="el-icon-close myclose_icon" @click="ruleForm.cuisineCheckd.splice(i,1)"></i></div>
                </el-form-item>
                <el-form-item label="Venue Address" prop="address">
                    <el-input v-model="ruleForm.address" maxlength="100" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Website">
                    <el-input v-model="ruleForm.website" maxlength="100" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Instagram Username">
                    <el-input v-model="ruleForm.username" maxlength="100" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Facebook Page">
                    <el-input v-model="ruleForm.facebook" maxlength="100" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Lease End Date" prop="leaseTime" style="position:relative">
                    <div class="timeshowBox" style="width:170px">{{showTime1}}</div>
                    <el-date-picker
					v-model="ruleForm.leaseTime"
					class="venueInformation_input"
					style="width:100%"
                    :clearable="true"
                    @change="changeTime(1)"
					type="date"
					format="dd/MM/yyyy"
					placeholder="">
					</el-date-picker>
                </el-form-item>
                <el-form-item label="Does the Rental Agreement include outgoings?">
                    <div class="checkBox_list">
                        <div class="venue_checkBox">
                            <span v-if="ruleForm.does==0" @click="ruleForm.does=1" class="venue_check"></span>
                            <span v-else class="venue_checked"></span>
                            <span class="venueCheckBox_msg">Yes</span>
                        </div>
                        <div class="venue_checkBox">
                            <span v-if="ruleForm.does==1"  @click="ruleForm.does=0" class="venue_check"></span>
                            <span v-else class="venue_checked"></span>
                            <span class="venueCheckBox_msg">No</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" :required="false">
                    <!-- <el-input v-model="ruleForm.rental" maxlength="10" class="venueInformation_input increaseInput">
                        <span slot="prefix" class="increaseIcon">$</span>
                    </el-input> -->
                    <div class="checkBox_list">
                        <el-col :span="12" style="margin-right:30px">
                            <el-form-item label="Monthly Rental Cost" prop="rental">
                                <div class="venue_checkBox1 increaseInput">
                                    <el-input v-model="ruleForm.rental" maxlength="10"  @input="changeM" class="venueInformation_input">
                                        <span slot="prefix" class="increaseIcon">$</span>
                                    </el-input>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Annual Rental Cost" prop="rental1">
                                <div class="venue_checkBox1">
                                    <el-input v-model="ruleForm.rental1" maxlength="10" @input="changeY" class="venueInformation_input increaseInput">
                                        <span slot="prefix" class="increaseIcon">$</span>
                                    </el-input>
                                </div>
                            </el-form-item>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="Yearly Rental Increase In % Or $ Value" :required="false">
					 <div class="checkBox_list">
                        <el-col :span="12" style="margin-right:30px">
                        <el-form-item prop="increase1">
                        <!-- <el-form-item prop="increase1" :rules="ruleForm.increaseType==1?[{ required: true, message: ' ', trigger: 'blur' }]:[]" ref="increase1"> -->
                            <div class="venue_checkBox1">
                                <span v-if="ruleForm.increaseType==0" @click="changeIncre(1)" class="venue_check"></span>
                                <span v-else class="venue_checked"></span>
                                <el-input v-model="ruleForm.increase1" maxlength="6" :disabled="ruleForm.increaseType==0" class="venueInformation_input">
                                    <span slot="suffix" class="increaseIcon">%</span>
                                </el-input>
                            </div>
                        </el-form-item>
                         </el-col>
                         <el-col :span="12">
                        <el-form-item prop="increase2">
                        <!-- <el-form-item prop="increase2" :rules="ruleForm.increaseType==0?[{ required: true, message: ' ', trigger: 'blur' }]:[]" ref="increase2"> -->
                            <div class="venue_checkBox1">
                                <span v-if="ruleForm.increaseType==1"  @click="changeIncre(2)" class="venue_check"></span>
                                <span v-else class="venue_checked"></span>
                                <el-input v-model="ruleForm.increase2" maxlength="10" @blur="increase2Blur" :disabled="ruleForm.increaseType==1" class="venueInformation_input increaseInput">
                                    <span slot="prefix" class="increaseIcon">$</span>
                                </el-input>
                            </div>
                        </el-form-item>
                         </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="Yearly Rental Increase Date" prop="IncreaseTime">
                    <div class="timeshowBox" style="width:100%">
                        <i class="el-icon-date"></i>
                        {{showTime2}}</div>
                    <el-cascader @change="changeTime(2)" class="timeshowBox1" style="z-index:1;width:100%;opacity:0" :options="dateOptions" separator=" " placeholder="" v-model="ruleForm.IncreaseTime"></el-cascader>
                </el-form-item>
                <el-form-item label="Rent Free Period" prop="free">
                    <el-input v-model="ruleForm.free" maxlength="10" class="venueInformation_input">
						<span slot="suffix" class="increaseIcon">months</span>
					</el-input>
                </el-form-item>
                <el-form-item label="Additional Amount" prop="amount">
                    <el-input v-model="ruleForm.amount" class="venueInformation_input increaseInput">
						<span slot="prefix" class="increaseIcon">$</span>
					</el-input>
                </el-form-item>
                <el-form-item label="Card Number">
                    <el-input v-model="ruleForm.cardNumber" maxlength="16" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Full Name">
                    <el-input v-model="ruleForm.cardName" maxlength="30" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="" :required="false">
                    <div class="checkBox_list">
                        <el-col :span="12" style="margin-right:30px">
                            <el-form-item label="Expire" prop="">
                                <!-- <div class="venue_checkBox1">
                                    <el-input v-model="ruleForm.expireMonth" maxlength="2" class="venueInformation_input">
                                    </el-input>
                                </div> -->
                                <div class="expireBox_inside">
                                    <input v-model="ruleForm.expireMonth" auto-complete="off" class="border-input1" ref="expMonth" maxlength="2" @keyup="nextFocus1($event,0,ruleForm.expireMonth)">
                                    <span style="line-height:40px;color:#fff;">/</span>             
                                    <input v-model="ruleForm.expireYear" auto-complete="off"  class="border-input1" ref="expYear" maxlength="2" @keyup="nextFocus1($event,1,ruleForm.expireYear)">
                                </div> 
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="CVV" prop="">
                                <div class="venue_checkBox1">
                                    <el-input type="password" autocomplete="new-password" v-model="ruleForm.cardCvv" maxlength="3" class="venueInformation_input">
                                    </el-input>
                                </div>
                            </el-form-item>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="Monthly Fee" prop='monthFee'>
                    <el-input v-model="ruleForm.monthFee" maxlength="10" class="venueInformation_input increaseInput">
                        <span slot="prefix" class="increaseIcon">$</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="Opening Hours">
                    <el-table
                    :data="ruleForm.hours"
                    border
                    class="venue_table"
                    style="width: 100%">
                        <el-table-column
                        prop="week"
                        align="center"
                        width="150"
                        label-class-name="roster_th"
                        class-name="roster_row"
                        label="Week">
                        </el-table-column>
                        <el-table-column
                        prop="time"
                        align="left"
                        label-class-name="roster_th"
                        class-name="roster_row"
                        label="Time">
                            <template slot-scope="scope">
                                <span v-if="scope.row.time">{{scope.row.time}}</span>
                                <span v-else>Closed</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="address"
                        align="center"
                        width="250"
                        label-class-name="roster_th"
                        class-name="roster_row"
                        label="Operating">
                            <template slot-scope="scope">
                                <span class="v_table_option_add" @click="addTime(scope.row)">Add</span>
                                <span class="v_table_option_add" @click="delTime(scope.$index,scope.row)" style="color:#EA3796">Reset</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="Usernmae" prop='newUserName'>
                    <el-input v-model="ruleForm.newUserName" maxlength="30" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Password" prop='password'>
                    <el-input type="password" autocomplete="new-password" v-model="ruleForm.password" maxlength="16" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item class="foot_box">
                    <el-button @click="cancel" class="cardCanBtn">Cancel</el-button>
                    <el-button @click="confirm" :disabled="isDisableConfirmBtn" class="cardConBtn">Confirm</el-button>
                </el-form-item>
            </el-form>
        </div>

        <cuisineDio 
        v-if="cuisineDio"
        :cuisineDio='cuisineDio'
        :cuisineListCheckF='cuisineListChecked'  
        @close='cuisineDio=false' 
        @addCuisin='addCuisin'/>
        <!-- 添加时间 -->
        <timePicker v-if="addTimeDio" :addTimeDio="addTimeDio" @cancel="addTimeDio=false" @add="addTimed"></timePicker>
    </div>
</template>

<script>
import timePicker from '../common/timepicker.vue';
import cuisineDio from '../common/cuisineDio.vue';
import dateOptions from '../../utils/time'
import api from '../../api/dishi.js';
export default {
    data() {
        var checkabn = (rule, value, callback) => {
            if (!value) {
                return callback(new Error(' '));
            }
            setTimeout(() => {
                if (value.length < 11) {
                    callback(new Error('Please enter an 11-digit ABN'));
                } else {
                    callback();
                }
            }, 200);
        };
        return {
            dateOptions:dateOptions,
            showTime1:'',
            showTime2:'',
            cuisineDio:false,
            cuisineListChecked:[],
            addTimeDio:false,
            addTimeDay:'', //添加时间标识
            rules:{ // 表单验证
                name:[{ required: true, message: ' ', trigger: 'blur' }],
                owner:[{ required: true, message: ' ', trigger: 'blur' }],
                abn:[{ required:true, validator: checkabn, trigger: 'blur' }],
                address:[{ required: true, message: ' ', trigger: 'blur' }],
                contactNumber:[{ required: true, message: ' ', trigger: 'blur' }],
                website:[{ required: true, message: ' ', trigger: 'blur' }],
                username:[{ required: true, message: ' ', trigger: 'blur' }],
                facebook:[{ required: true, message: ' ', trigger: 'blur' }],
                leaseTime:[{ required: false, message: ' ', trigger: 'change' }],
                rental:[{ required: false, message: ' ', trigger: 'blur' }],
                rental1:[{ required: false, message: ' ', trigger: 'blur' }],
                newUserName:[{ required: true, message: ' ', trigger: 'blur' }],
                password:[{ required: true, message: ' ', trigger: 'blur' }],
                monthFee:[{ required: true, message: ' ', trigger: 'blur' }],
                // increase1:[{ required: true, message: ' ', trigger: 'blur' }],
                // increase2:[{ required: true, message: ' ', trigger: 'blur' }],
                IncreaseTime:[{ required: false, message: ' ', trigger: 'change' }],
                // free:[{ required: true, message: ' ', trigger: 'blur' }],
                // amount:[{ required: true, message: ' ', trigger: 'blur' }]
            },
            timeNum:0,
            itemTime:'',
            ruleForm:{ // 表单数据
                name:'',
                owner:'',
                abn:'',
                address:'',
                website:'',
                username:'',
                facebook:'',
                description:[],
                bar:0,
                cafe:0,
                restaurant:0,
                cuisineCheckd:[], //cuisine type 选中的值
                restaurantCkeck:'Fast Food',
                hours:[
                    {week:'Mon',time:''},
                    {week:'Tues',time:''},
                    {week:'Wed',time:''},
                    {week:'Thu',time:''},
                    {week:'Fri',time:''},
                    {week:'Sat',time:''},
                    {week:'Sun',time:''},
                ],
                // 1.23
                leaseTime:'',
				does:1, //单选框默认选中
				rental:'',
				rental1:'',
				increaseType:1,
				increase1:'',
				increase2:'',
				IncreaseTime:'',
				free:'',
                amount:'',
                er:'',
                newUserName:'',
                password:'',
                monthFee:'',
                contactNumber:'',
                cardNumber:'',
                cardName:'',
                cardCvv:'',
                expireMonth:"",
                expireYear:""
            },
        }
    },
    components:{
        timePicker,
        cuisineDio
    },
    methods: {
        showDescriptionSel(){ 
            this.ruleForm.restaurant==1?this.ruleForm.restaurant=0:this.ruleForm.restaurant=1;
            if(this.ruleForm.restaurant==0) this.ruleForm.restaurantCkeck='Fast Food';
        },
        showCuisDio(){
            this.cuisineListChecked=JSON.parse(JSON.stringify(this.ruleForm.cuisineCheckd))
            this.cuisineDio=true
        },
        addCuisin(val){ // 添加选项
            this.ruleForm.cuisineCheckd=JSON.parse(JSON.stringify(val))
            this.cuisineListChecked = []
            this.cuisineDio = false
        },
        addTime(val){ // 打开时间弹框
            this.addTimeDay=val.week
            this.addTimeDio=true
        },
        delTime(i,val){ // 删除时间
            this.ruleForm.hours[i].time=''
        },
        addTimed(val){ // 添加时间
            this.timeNum = 0
            this.ruleForm.hours.forEach(item=>{
                if(item.week==this.addTimeDay){
                    let arr=item.time?item.time.split(','):[]
                    arr.push(val)
                    item.time=arr.join(',')
                }
                if(item.time){
                    this.itemTime = item.time
                    this.timeNum++
                }
            })
            if(this.timeNum==1){ // 只有一个时间
                this.ruleForm.hours.forEach(item=>{
                    item.time = this.itemTime
                })
            }  
            this.addTimeDio=false
        },
        cancel(){ // 返回
            this.$router.go(-1)
        },
        confirm(){ // 提交
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let pat={
                        venueName:this.ruleForm.name,
                        venueOwner:this.ruleForm.owner,
                        abn:this.ruleForm.abn,
                        venueMobile:this.ruleForm.contactNumber,
                        venueDescription:'',
                        cuisineType:this.ruleForm.cuisineCheckd.join(','),
                        venueAddress:this.ruleForm.address,
                        website:this.ruleForm.website,
                        instagramUsername:this.ruleForm.username,
                        facebookPage:this.ruleForm.facebook,
                        venueAddress:this.ruleForm.address,
                        venueOpenAddVoList:[],
                        // 1.23 new add
                        leaseEndDate:(this.ruleForm.leaseTime)/1000, //结束日期
                        yearlyRentalIncreaseType:this.ruleForm.increaseType==1?1:0, //增长类型
                        yearlyRentalIncrease:this.ruleForm.increaseType==1?this.ruleForm.increase1:this.ruleForm.increase2?this.ruleForm.increase2:0, // 增长幅度
                        // yearlyRentalIncreaseDate:(this.ruleForm.IncreaseTime)/1000, // 增长时间
                        yearlyRentalIncreaseDate:this.ruleForm.IncreaseTime[0]+ '-' +this.ruleForm.IncreaseTime[1], // 增长时间
                        rentFreePeriod:this.ruleForm.free, //免租期
                        additionalAmount:this.ruleForm.amount, // 额外金额
                        monthlyRentalCost:this.ruleForm.rental, // 月租金
                        yearRentalCost:this.ruleForm.rental1, // 年租金
                        includeOutgoings:this.ruleForm.does==1?1:0,
                        password: this.ruleForm.password,
                        userName: this.ruleForm.newUserName,
                        monthlyFee:this.ruleForm.monthFee,
                        cardName: this.ruleForm.cardName,
                        cardNumber: this.ruleForm.cardNumber,
                        cvv: this.ruleForm.cardCvv,
                        expire: (this.ruleForm.expireMonth&&this.ruleForm.expireYear)?`${this.ruleForm.expireMonth}/${this.ruleForm.expireYear}`:'',
                    }
                    // 描述
                    let descriptionList=[]
                    this.ruleForm.bar?descriptionList.push('Bar'):'';
                    this.ruleForm.cafe?descriptionList.push('Cafe'):'';
                    this.ruleForm.restaurant?descriptionList.push(this.ruleForm.restaurantCkeck):'';
                    pat.venueDescription=descriptionList.join(',')
                    // 时间
                    pat.venueOpenAddVoList=this.ruleForm.hours.map(item=>{
                        let obj={
                            week:item.week=='Mon'?'Monday':item.week=='Tues'?'Tuesday':item.week=='Thu'?'Thursday':item.week=='Fri'?'Friday':item.week=='Sat'?'Saturday':item.week=='Sun'?'Sunday':'Wednesday',
                            openTime:item.time
                        }
                        return obj
                    })        
                    api.createVenue(pat,res=>{
                        let {code,data,message}=res.data;
                        if(code==0){
                             this.$router.go(-1)
                        }else{
                            Utils.alert('',message,'error')
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        getdetail(){
            api.getVenueInfo({},res=>{
                let {code,data,message}=res.data;
                if(code==0){
                    this.ruleForm.name=data.venueName
                    this.ruleForm.owner=data.venueOwner
                    this.ruleForm.abn=data.abn
                    this.cuisineListShow=data.cuisineType.split(',')
                    this.ruleForm.cuisineCheckd=data.cuisineType.split(',')
                    this.ruleForm.address=data.venueAddress
                    this.ruleForm.website=data.website
                    this.ruleForm.username=data.instagramUsername
                    this.ruleForm.facebook=data.facebookPage
                    // this.ruleForm.hours=data.venueOpenUpdateVoList
                    data.venueDescription.split(',').forEach(item=>{
                        switch (item) {
                            case "Bar":
                                this.ruleForm.bar=1
                            break;
                            case "Cafe":
                                this.ruleForm.cafe=1
                            break;
                            case "Café":
                                this.ruleForm.cafe=1
                            break;
                            default:
                                if(item){
                                    this.ruleForm.restaurant=1
                                    this.ruleForm.restaurantCkeck=item
                                }
                            break;
                        }
                    })
                    if(data.venueOpenList.length){
                        this.ruleForm.hours = data.venueOpenList.map(item=>{
                            switch (item.week) {
                                case "Monday":
                                    return {
                                        week:'Mon',
                                        time:item.openTime!='Closed'?item.openTime:''
                                    }
                                break;
                                case "Tuesday":
                                    return {
                                        week:'Tues',
                                        time:item.openTime!='Closed'?item.openTime:''
                                    }
                                break;
                                case "Thursday":
                                    return {
                                        week:'Thu',
                                        time:item.openTime!='Closed'?item.openTime:''
                                    }
                                break;
                                case "Friday":
                                    return {
                                        week:'Fri',
                                        time:item.openTime!='Closed'?item.openTime:''
                                    }
                                break;
                                case "Saturday":
                                    return {
                                        week:'Sat',
                                        time:item.openTime!='Closed'?item.openTime:''
                                    }
                                break;
                                case "Sunday":
                                    return {
                                        week:'Sun',
                                        time:item.openTime!='Closed'?item.openTime:''
                                    }
                                break;
                                case "Wednesday":
                                    return {
                                        week:'Wed',
                                        time:item.openTime!='Closed'?item.openTime:''
                                    }
                                break;
                            }
                        })
                    }
                }else{
                    Utils.alert('',message,'error')
                }
            })
        },
        changeM(){
            this.ruleForm.rental1 = this.ruleForm.rental?(this.ruleForm.rental*12).toFixed(2):0
        },
        changeY(){
            this.ruleForm.rental = this.ruleForm.rental1?(this.ruleForm.rental1/12).toFixed(2):0
        },
        changeIncre(key){
            if(key==1){
                this.$nextTick(()=>{
                    this.ruleForm.increaseType=1;
                    this.ruleForm.increase2='';
                    // this.$refs['increase2'].clearValidate();
                })
            }
            else{
                this.$nextTick(()=>{
                    this.ruleForm.increaseType=0;
                    this.ruleForm.increase1='';
                    // this.$refs['increase1'].clearValidate();
                })
            }
        },
        increase2Blur(){
            this.$refs['ruleForm'].validateField('increase2');
        },
        changeTime(key){
            if(key == 1){
                this.ruleForm.leaseTime?this.showTime1=Utils.timestampToTime(this.ruleForm.leaseTime):this.showTime1 = ''
            }else{ // 
                // this.ruleForm.IncreaseTime?this.showTime2=Utils.timestampToTime(this.ruleForm.IncreaseTime):this.showTime2 = ''
                this.getShowTime()
            }
        },
        getShowTime(){
            let M = this.ruleForm.IncreaseTime[0]
            if (M === '01') {
                M = 'Jan'
            } else if (M === '02') {
                M = 'Feb'
            } else if (M === '03') {
                M = 'Mar'
            } else if (M === '04') {
                M = 'Apr'
            } else if (M === '05') {
                M = 'May'
            } else if (M === '06') {
                M = 'Jun'
            } else if (M === '07') {
                M = 'Jul'
            } else if (M === '08') {
                M = 'Aug'
            } else if (M === '09') {
                M = 'Sep'
            } else if (M === '10') {
                M = 'Oct'
            } else if (M === '11') {
                M = 'Nov'
            } else if (M === '12') {
                M = 'Dec'
            }
            this.ruleForm.IncreaseTime?this.showTime2 = this.ruleForm.IncreaseTime[1] + ' ' + M:this.showTime2 = ''
        },
        nextFocus(el,index,val) {
            var dom = document.getElementsByClassName("border-input"),
            currInput = dom[index],
            nextInput = dom[index + 1],
            lastInput = dom[index - 1];
            if (el.keyCode != 8&&val.split('').length==4) { //8为删除
                if (index < 3) {
                    nextInput.focus();
                } else {
                    currInput.blur();
                }
            }else if(val.split('').length==0){
                if (index !=0) {
                    lastInput.focus();
                }
            }
        },
        nextFocus1(el,index,val) {
            var dom = document.getElementsByClassName("border-input1"),
            currInput = dom[index],
            nextInput = dom[index + 1],
            lastInput = dom[index - 1];
            if (el.keyCode != 8&&val.split('').length==2) { //8为删除
                if (index < 1) {
                    nextInput.focus();
                } else {
                    currInput.blur();
                }
            }else if(val.split('').length==0){
                if (index !=0) {
                    lastInput.focus();
                }
            }
        },
    },
    computed: {
        isDisableConfirmBtn(){
            const flag = (!this.ruleForm.name||!this.ruleForm.owner||!this.ruleForm.abn||!this.ruleForm.address||!this.ruleForm.contactNumber||!this.ruleForm.cuisineCheckd.length||!this.ruleForm.monthFee||!this.ruleForm.newUserName||!this.ruleForm.password||(!this.ruleForm.bar&&!this.ruleForm.cafe&&!this.ruleForm.restaurant))
            return flag
        },
        contactNumber(){
            return this.ruleForm.contactNumber
        },
        abn(){
            return this.ruleForm.abn
        },
        nrental(){
            return this.ruleForm.rental
        },
        rental1(){
            return this.ruleForm.rental1
        },
        nincrease1(){
            return this.ruleForm.increase1
        },
        nincrease2(){
            return this.ruleForm.increase2
        },
        nfree(){
            return this.ruleForm.free
        },
        namount(){
            return this.ruleForm.amount
        },
        monthFee(){
            return this.ruleForm.monthFee
        },
        newexpMonth(){
            return this.ruleForm.expireMonth
        },
        newexpYear(){
            return this.ruleForm.expireYear
        },
        cardNum(){
            return this.ruleForm.cardNumber
        },
        cardCvv(){
            return this.ruleForm.cardCvv
        },
    },
    watch: {
        newexpMonth(n,o){
            if(n){
                let reg = /^\d+(\d)?$/;
                if (new RegExp(reg).test(n) == false && n!='') {
                    setTimeout(() => {
                        this.ruleForm.expireMonth = o;
                    }, 100);
                }
                if(n>12){
                    this.ruleForm.expireMonth = o;
                }
            }
        },
        newexpYear(n,o){
            if(n){
                let reg = /^\d+(\d)?$/;
                if (new RegExp(reg).test(n) == false && n!='') {
                    setTimeout(() => {
                        this.ruleForm.expireYear = o;
                    }, 100);
                }
            }
        },
        cardCvv(n,o){
			if(n != ''){
                let reg = /^\d+(\d)?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.cardCvv = o;
					}, 50);
				}
			}
		},
        cardNum(n,o){
			if(n != ''){
                let reg = /^\d+(\d)?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.cardNumber = o;
					}, 50);
				}
			}
		},
        abn(n,o){
			if(n != ''){
                let reg = /^\d+(\d)?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.abn = o;
					}, 50);
				}
			}
		},
        contactNumber(n,o){
			if(n != ''){
                let reg = /^\d+(\d)?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.contactNumber = o;
					}, 50);
				}
			}
		},
        nrental(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.rental = o;
					}, 50);
				}
			}
		},
        monthFee(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.monthFee = o;
					}, 50);
				}
			}
		},
        rental1(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.rental1 = o;
					}, 50);
				}
			}
		},
        nincrease1(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.increase1 = o;
					}, 50);
				}
				if(n > 100){
					setTimeout(()=>{
						this.ruleForm.increase1=100
					},50)
				}
			}
        },
        nincrease2(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.increase2 = o;
					}, 50);
				}
			}
		},
        nfree(n,o){
			if(n != ''){
                let reg = /^\d+(\d)?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.free = o;
					}, 50);
				}
			}
		},
        namount(n,o){
            if(n){
                let reg = /^\d+(\.\d{0,2})?$/;
                if (new RegExp(reg).test(n) == false && n!='') {
                    setTimeout(() => {
                        this.ruleForm.amount = o;
                    }, 100);
                }
            }
		}
    },
}
</script>

<style lang="scss">
    .information_box{
        position: relative;
        .inform_tit{
            height:76px;
            font-size:14px;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:20px;
            width: 100%;
            background-color: #212429;
            z-index: 100;
            .cancel_box{
                cursor: pointer;
                width: 150px;
            }
        }
        .inMain_box{
            background-color: #2b3444;
            width: 100%;
            box-sizing: border-box;
            padding:50px 20%;
            margin-bottom: 40px;
            .informdata_tit{
                text-align: left;
                margin-bottom: 50px;
                height:42px;
                font-size:30px;
                font-weight:600;
                color:rgba(255,255,255,1);
                line-height:42px;
            }
            .checkBox_list{
                display: flex;
                // height: 40px;
                align-items: center;
            }
            .venue_checkBox{
                display: flex;
                align-items: center;
                margin-right: 65px;
                .venue_check{
                    width:16px;
                    height:16px;
                    box-sizing: border-box;
                    background:rgba(43,52,68,1);
                    border-radius:1px;
                    border:1px solid rgba(95,95,95,1);
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venue_checked{
                    width:16px;
                    height:16px;
                    border: none;
                    background: url("../../../static/img/correct.png");
                    background-size: cover;
                    border-radius:1px;
                    background-repeat: no-repeat;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venueCheckBox_msg{
                    cursor: pointer;
                    height:28px;
                    width: 100px;
                    font-size:20px;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    line-height:28px;
                }
            }
            .venue_checkBox1{
                display: flex;
                align-items: center;
				margin-right: 30px;
                width: 100%;
                .venue_check{
                    min-width: 17px;
                    width:17px;
                    height:16px;
                    box-sizing: border-box;
                    background:rgba(43,52,68,1);
                    border-radius:50%;
                    border:1px solid rgba(95,95,95,1);
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venue_checked{
                    min-width: 17px;
                    width:17px;
                    height:16px;
                    background: url("../../../static/img/Shape.png");
                    background-size: cover;
                    border-radius:50%;
                    background-repeat: no-repeat;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venueCheckBox_msg{
                    height:28px;
                    font-size:20px;
                    font-family:PingFang SC;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    line-height:28px;
                }
            }
            .venueAddtype_btn{
                width:150px;
                height:40px;
                padding: 10px 20px !important;
                background:rgba(43,52,68,1);
                border:1px solid rgba(209,58,144,1);
                font-size:20px;
                font-weight:400;
                color:rgba(209,58,144,1);
                margin-right: 30px;
            }
            .venueType_box{
                display: inline-block;
                padding:0 20px;
                height:40px;
                line-height: 40px;
                background:rgba(21,28,39,1);
                border:1px solid rgba(95,95,95,1);
                font-size: 20px;
                color: #ffffff;
                vertical-align: top;
                box-sizing: border-box;
                margin:0 30px 20px 0;
                position: relative;
                border-radius: 4px;
                .myclose_icon{
                    position: absolute;
                    top: -12px;
                    right: -12px;
                    background-color: #fff;
                    color: #2B3444;
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    font-size: 15px;
                    font-weight: 600;
                    line-height: 20px;
                    text-align: center;
                    cursor: pointer;
                }
            }
            .v_table_option_add{
                height:25px;
                font-size:18px;
                font-weight:400;
                color:rgba(255,255,255,1);
                line-height:25px;
                margin-right: 25px;
                cursor: pointer;
                &:last-child{
                    margin-right: 0px;
                }
            }
        }
    }
    .checked{
        color: #D13A90 !important;
    }
    .increaseIcon{
		line-height: 40px;
		font-size: 18px;
		color: #fff;
		&:first-child{
			margin-right: 20px;
		}
		&:last-child{
			margin-left: 20px;
		}
	}
    .leftIn-enter-active, .leftIn-in-leave-active {
        width: 200px;
        transition: opacity .4s ease;
    }
    .leftIn-in-enter, .leftIn-in-leave-to {
        opacity: 0;
        width: 0px;
    }
    .timeshowBox{
        position: absolute;
        width: 355px;
        border: 1px solid #5f5f5f;
        border-radius: 4px;
        z-index: 0;
        height: 38px;
        line-height: 38px;
        top:1px;
        padding-left: 10px;
        font-size: 20px;
        color: #fff;
        left: 0px;
        background-color: #151c27;
    }
    .timeshowBox1{
        .el-input.is-focus{
            border-color: #565758 !important;
        }
        .el-input__inner{
            width: 100%;
            z-index: 10;
            height: 40px;
            padding-left: 30px !important;
            top:1px;
            font-size: 20px;
            color: #fff;
            padding-left: 15px;
            border: 1px solid #565758;
            border-radius: 4px;
            background-color: #151c27;
            &:hover{
                border: 1px solid #565758 !important;
            }
            &:focus{
                border: 1px solid #565758 !important;
            }
        }
        .el-input__suffix{
            display: none !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/doshi/createVenue.vue